import ChatHome from '@/screens/ChatHome';

export default function PrivateTabsChatIndexRoute() {
  return <ChatHome />;
}
